/**
 * FacetWP Customizations
 * Si carica solo se FacetWP è presente in pagina (frontend pubblico).
 * Vanilla JavaScript - no dependencies.
 *
 * @package Celada
 */

(function () {
	'use strict';

	// // Verifica che FacetWP sia caricato
	// if (typeof FWP === 'undefined') {
	// 	return;
	// }



	/**
	 * Aggiungi classe "no-results" al template se non ci sono risultati
	 */
	function handleNoResults() {
		const templates = document.querySelectorAll('.facetwp-template');
		
		templates.forEach(function (template) {
			// Cerca i risultati reali escludendo il messaggio "no results"
			const results = template.querySelectorAll('li:not(.facetwp-no-results)');
			
			if (results.length === 0) {
				template.classList.add('no-results');
			} else {
				template.classList.remove('no-results');
			}
		});
	}

	/**
	 * Gestione stato loading
	 */
	function handleLoadingStart() {
		const templates = document.querySelectorAll('.facetwp-template');
		templates.forEach(function (template) {
			template.classList.add('is-loading');
		});
	}

	function handleLoadingEnd() {
		const templates = document.querySelectorAll('.facetwp-template');
		templates.forEach(function (template) {
			template.classList.remove('is-loading');
		});
	}

	/**
	 * Event listeners per FacetWP
	 * FacetWP usa jQuery per triggerare eventi, quindi usiamo jQuery per ascoltarli
	 */
	if (typeof jQuery !== 'undefined') {
		jQuery(document).on('facetwp-refresh', handleLoadingStart);

		jQuery(document).on('facetwp-loaded', function () {
			handleLoadingEnd();
			handleNoResults();
		});

		// Debug mode
		if (window.location.search.indexOf('fwp_debug=1') !== -1) {
			jQuery(document).on('facetwp-loaded', function () {
				// console.log('FacetWP Loaded:', FWP.facets);
				// console.log('Settings:', FWP.settings);
			});
		}
	}

	// Esegui al caricamento iniziale della pagina
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', handleNoResults);
	} else {
		handleNoResults();
	}

})();
